export const izjava1Lookup =
    [
        {
            id: "1", ime: "Прв пат аплицираме за сертификација според наведениот стандард во точка 4"
        }
    ]